import React from "react";
import {useFormContext} from "react-hook-form";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';

import * as CustomStyles from '../styles/CustomStyles';
import * as ValidationMessages from '../constants/ValidationMessages';
import * as DataPattern from '../constants/DataPattern';
import * as SelectData from '../constants/CustomSelectData';

//
// It is expected that <FormProvider> provides all the hook methods in the parent before calling the below components
// The components access the methods (register, formState, errors, etc...) by using useFormContext()
// lUser is expected to be in the local form state
//

export function RenderGeneralSection(props) {
    console.log('Sectiune Generala...');
    const { register, setValue, trigger, watch, formState: { errors, defaultValues } } = useFormContext();

    const [checkedActive, setCheckedActive] = React.useState(!!defaultValues.lUser.generalSection.active ? defaultValues.lUser.generalSection.active : false);
    const [selectedRoleId, setSelectedRoleId] = React.useState( !!defaultValues.lUser.generalSection.role ? defaultValues.lUser.generalSection.role : '');

    const [roleSelectData, setRoleSelectData] = React.useState( SelectData.roleSystem);


    React.useEffect(() => {
    }, []);      

    const handleRoleChange = (roleId) => {
        setSelectedRoleId(roleId);
    }


    return(
        <Box sx={CustomStyles.boxStyles}  >
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume Utilizator (Email)" fullWidth margin="dense" disabled={!!defaultValues.lUser.id}
                        {...register("lUser.generalSection.username", 
                        {required: ValidationMessages.REQUITED_MESSAGE,               
                            pattern: {
                                value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                            }  
                            }
                        )} 
                        error={!!errors?.lUser?.generalSection?.username}
                        helperText={errors?.lUser?.generalSection?.username ? errors.lUser.generalSection.username.message : null}
                        onChange={(event) => { 
                                setValue('lUser.generalSection.email', event.target.value); 
                                trigger('lUser.generalSection.email'); 
                            }
                        }
                    />
                </Grid>
                <Grid item xs={3}>
                </Grid>
                <Grid item xs={5}>
                    <FormControlLabel 
                        control={ 
                            <Checkbox
                                {...register('lUser.generalSection.active')}                         
                                checked={checkedActive} 
                                onChange={(event) => setCheckedActive(event.target.checked)}
                            /> 
                        } 
                        label="Activ" 
                    />
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nume" fullWidth margin="dense" 
                        {...register("lUser.generalSection.lastName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lUser?.generalSection?.lastName}
                        helperText={errors?.lUser?.generalSection.lastName ? errors.lUser.generalSection.lastName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Prenume" fullWidth margin="dense" 
                        {...register("lUser.generalSection.firstName", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lUser?.generalSection?.firstName}
                        helperText={errors?.lUser?.generalSection?.firstName ? errors.lUser.generalSection.firstName.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Email" fullWidth margin="dense" disabled
                        {...register("lUser.generalSection.email", 
                            {required: ValidationMessages.REQUITED_MESSAGE,               
                            pattern: {
                                value: DataPattern.PATTERN_EMAIL_ADDRESS,
                                message: ValidationMessages.INVALID_EMAIL_ADDRESS,
                            }  
                            }
                        )} 
                        error={!!errors?.lUser?.generalSection?.email}
                        helperText={errors?.lUser?.generalSection?.email ? errors.lUser.generalSection.email.message : null}
                        inputRef={register()}
                        InputLabelProps={{ shrink: !!watch('lUser.generalSection.email') }}
                        />
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <FormControl fullWidth size="small" margin="dense" variant="standard">
                        <InputLabel id={'daRole-inputLabelId'} error={!!errors?.lUser?.generalSection?.role}>Rol Utilizator</InputLabel>
                        <Select
                            {...register('lUser.generalSection.role', {required: ValidationMessages.REQUITED_MESSAGE})}
                            labelId={'daRole-selectLabelId'}
                            id={'daRole'}
                            value={selectedRoleId}
                            onChange={(event) => handleRoleChange(event.target.value)}
                            label={'daRole-label'}
                            error={!!errors?.lUser?.generalSection?.role}
                            >
                            {
                                roleSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                            }
                        </Select>
                        <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lUser?.generalSection?.role ? errors.lUser.generalSection.role.message : null}</Typography>
                    </FormControl>
                </Grid>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={4}>
                </Grid>

            </Grid>
        </Box>
    );
}



